export const ELEMENTS = ['metal', 'wood', 'water', 'fire', 'earth'] as const;
export type Element = (typeof ELEMENTS)[number];

/**
 * Wu Xing overcoming (ke) cycle: each element overcomes the next.
 * Metal cuts Wood, Wood parts Earth, Earth dams Water, Water quenches Fire, Fire melts Metal.
 */
export const OVERCOMES: Readonly<Record<Element, Element>> = {
  metal: 'wood',
  wood: 'earth',
  earth: 'water',
  water: 'fire',
  fire: 'metal',
};

export const ELEMENT_INFO: Readonly<Record<Element, { name: string; nameZh: string; color: string }>> = {
  metal: { name: 'Metal', nameZh: '金', color: '#e8d9a8' },
  wood: { name: 'Wood', nameZh: '木', color: '#6fbf73' },
  water: { name: 'Water', nameZh: '水', color: '#5fa8e8' },
  fire: { name: 'Fire', nameZh: '火', color: '#e8643c' },
  earth: { name: 'Earth', nameZh: '土', color: '#d4a54a' },
};
